/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.FinancialsFiscalReport = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The FinancialsFiscalReport model module.
   * @module model/FinancialsFiscalReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>FinancialsFiscalReport</code>.
   * @alias module:model/FinancialsFiscalReport
   * @class
   */
  var exports = function() {
    var _this = this;


































  };

  /**
   * Constructs a <code>FinancialsFiscalReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/FinancialsFiscalReport} obj Optional instance to populate.
   * @return {module:model/FinancialsFiscalReport} The populated <code>FinancialsFiscalReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('FiscalPeriodEnd')) {
        obj['FiscalPeriodEnd'] = ApiClient.convertToType(data['FiscalPeriodEnd'], 'Date');
      }
      if (data.hasOwnProperty('FiscalPeriodStart')) {
        obj['FiscalPeriodStart'] = ApiClient.convertToType(data['FiscalPeriodStart'], 'Date');
      }
      if (data.hasOwnProperty('EmployeeCount')) {
        obj['EmployeeCount'] = ApiClient.convertToType(data['EmployeeCount'], 'Integer');
      }
      if (data.hasOwnProperty('FiscalResult')) {
        obj['FiscalResult'] = ApiClient.convertToType(data['FiscalResult'], 'Integer');
      }
      if (data.hasOwnProperty('Result')) {
        obj['Result'] = ApiClient.convertToType(data['Result'], 'Integer');
      }
      if (data.hasOwnProperty('Revenue')) {
        obj['Revenue'] = ApiClient.convertToType(data['Revenue'], 'Integer');
      }
      if (data.hasOwnProperty('ExternalServices')) {
        obj['ExternalServices'] = ApiClient.convertToType(data['ExternalServices'], 'Integer');
      }
      if (data.hasOwnProperty('WagesAndSalaries')) {
        obj['WagesAndSalaries'] = ApiClient.convertToType(data['WagesAndSalaries'], 'Integer');
      }
      if (data.hasOwnProperty('Purchases')) {
        obj['Purchases'] = ApiClient.convertToType(data['Purchases'], 'Integer');
      }
      if (data.hasOwnProperty('SocialSecurityExpenses')) {
        obj['SocialSecurityExpenses'] = ApiClient.convertToType(data['SocialSecurityExpenses'], 'Integer');
      }
      if (data.hasOwnProperty('OtherOperatingCharges')) {
        obj['OtherOperatingCharges'] = ApiClient.convertToType(data['OtherOperatingCharges'], 'Integer');
      }
      if (data.hasOwnProperty('DepreciationAndReductionInValue')) {
        obj['DepreciationAndReductionInValue'] = ApiClient.convertToType(data['DepreciationAndReductionInValue'], 'Integer');
      }
      if (data.hasOwnProperty('OtherInterestAndFinancialIncome')) {
        obj['OtherInterestAndFinancialIncome'] = ApiClient.convertToType(data['OtherInterestAndFinancialIncome'], 'Integer');
      }
      if (data.hasOwnProperty('InterestAndOtherFinancialExpenses')) {
        obj['InterestAndOtherFinancialExpenses'] = ApiClient.convertToType(data['InterestAndOtherFinancialExpenses'], 'Integer');
      }
      if (data.hasOwnProperty('Ebit')) {
        obj['Ebit'] = ApiClient.convertToType(data['Ebit'], 'Integer');
      }
      if (data.hasOwnProperty('Ebitda')) {
        obj['Ebitda'] = ApiClient.convertToType(data['Ebitda'], 'Integer');
      }
      if (data.hasOwnProperty('DepreciationReserve')) {
        obj['DepreciationReserve'] = ApiClient.convertToType(data['DepreciationReserve'], 'Integer');
      }
      if (data.hasOwnProperty('IntangibleRights')) {
        obj['IntangibleRights'] = ApiClient.convertToType(data['IntangibleRights'], 'Integer');
      }
      if (data.hasOwnProperty('OtherCapitalisedLongtermExpenses')) {
        obj['OtherCapitalisedLongtermExpenses'] = ApiClient.convertToType(data['OtherCapitalisedLongtermExpenses'], 'Integer');
      }
      if (data.hasOwnProperty('IntangibleAssets')) {
        obj['IntangibleAssets'] = ApiClient.convertToType(data['IntangibleAssets'], 'Integer');
      }
      if (data.hasOwnProperty('MachineryAndEquipment')) {
        obj['MachineryAndEquipment'] = ApiClient.convertToType(data['MachineryAndEquipment'], 'Integer');
      }
      if (data.hasOwnProperty('AdvancePaymentsAndConstructionInProgress')) {
        obj['AdvancePaymentsAndConstructionInProgress'] = ApiClient.convertToType(data['AdvancePaymentsAndConstructionInProgress'], 'Integer');
      }
      if (data.hasOwnProperty('TangibleAssets')) {
        obj['TangibleAssets'] = ApiClient.convertToType(data['TangibleAssets'], 'Integer');
      }
      if (data.hasOwnProperty('HoldingsInGroupUndertakings')) {
        obj['HoldingsInGroupUndertakings'] = ApiClient.convertToType(data['HoldingsInGroupUndertakings'], 'Integer');
      }
      if (data.hasOwnProperty('Investments')) {
        obj['Investments'] = ApiClient.convertToType(data['Investments'], 'Integer');
      }
      if (data.hasOwnProperty('LongTermReceivables')) {
        obj['LongTermReceivables'] = ApiClient.convertToType(data['LongTermReceivables'], 'Integer');
      }
      if (data.hasOwnProperty('TradeDebtors')) {
        obj['TradeDebtors'] = ApiClient.convertToType(data['TradeDebtors'], 'Integer');
      }
      if (data.hasOwnProperty('ShortTermReceivables')) {
        obj['ShortTermReceivables'] = ApiClient.convertToType(data['ShortTermReceivables'], 'Integer');
      }
      if (data.hasOwnProperty('CashInHandAndAtBanks')) {
        obj['CashInHandAndAtBanks'] = ApiClient.convertToType(data['CashInHandAndAtBanks'], 'Integer');
      }
      if (data.hasOwnProperty('RetainedEarnings')) {
        obj['RetainedEarnings'] = ApiClient.convertToType(data['RetainedEarnings'], 'Integer');
      }
      if (data.hasOwnProperty('CapitalAndReserves')) {
        obj['CapitalAndReserves'] = ApiClient.convertToType(data['CapitalAndReserves'], 'Integer');
      }
      if (data.hasOwnProperty('LoansFromCreditInstitutions')) {
        obj['LoansFromCreditInstitutions'] = ApiClient.convertToType(data['LoansFromCreditInstitutions'], 'Integer');
      }
      if (data.hasOwnProperty('ShortTermCreditors')) {
        obj['ShortTermCreditors'] = ApiClient.convertToType(data['ShortTermCreditors'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Date} FiscalPeriodEnd
   */
  exports.prototype['FiscalPeriodEnd'] = undefined;
  /**
   * @member {Date} FiscalPeriodStart
   */
  exports.prototype['FiscalPeriodStart'] = undefined;
  /**
   * @member {Integer} EmployeeCount
   */
  exports.prototype['EmployeeCount'] = undefined;
  /**
   * @member {Integer} FiscalResult
   */
  exports.prototype['FiscalResult'] = undefined;
  /**
   * @member {Integer} Result
   */
  exports.prototype['Result'] = undefined;
  /**
   * @member {Integer} Revenue
   */
  exports.prototype['Revenue'] = undefined;
  /**
   * @member {Integer} ExternalServices
   */
  exports.prototype['ExternalServices'] = undefined;
  /**
   * @member {Integer} WagesAndSalaries
   */
  exports.prototype['WagesAndSalaries'] = undefined;
  /**
   * @member {Integer} Purchases
   */
  exports.prototype['Purchases'] = undefined;
  /**
   * @member {Integer} SocialSecurityExpenses
   */
  exports.prototype['SocialSecurityExpenses'] = undefined;
  /**
   * @member {Integer} OtherOperatingCharges
   */
  exports.prototype['OtherOperatingCharges'] = undefined;
  /**
   * @member {Integer} DepreciationAndReductionInValue
   */
  exports.prototype['DepreciationAndReductionInValue'] = undefined;
  /**
   * @member {Integer} OtherInterestAndFinancialIncome
   */
  exports.prototype['OtherInterestAndFinancialIncome'] = undefined;
  /**
   * @member {Integer} InterestAndOtherFinancialExpenses
   */
  exports.prototype['InterestAndOtherFinancialExpenses'] = undefined;
  /**
   * @member {Integer} Ebit
   */
  exports.prototype['Ebit'] = undefined;
  /**
   * @member {Integer} Ebitda
   */
  exports.prototype['Ebitda'] = undefined;
  /**
   * @member {Integer} DepreciationReserve
   */
  exports.prototype['DepreciationReserve'] = undefined;
  /**
   * @member {Integer} IntangibleRights
   */
  exports.prototype['IntangibleRights'] = undefined;
  /**
   * @member {Integer} OtherCapitalisedLongtermExpenses
   */
  exports.prototype['OtherCapitalisedLongtermExpenses'] = undefined;
  /**
   * @member {Integer} IntangibleAssets
   */
  exports.prototype['IntangibleAssets'] = undefined;
  /**
   * @member {Integer} MachineryAndEquipment
   */
  exports.prototype['MachineryAndEquipment'] = undefined;
  /**
   * @member {Integer} AdvancePaymentsAndConstructionInProgress
   */
  exports.prototype['AdvancePaymentsAndConstructionInProgress'] = undefined;
  /**
   * @member {Integer} TangibleAssets
   */
  exports.prototype['TangibleAssets'] = undefined;
  /**
   * @member {Integer} HoldingsInGroupUndertakings
   */
  exports.prototype['HoldingsInGroupUndertakings'] = undefined;
  /**
   * @member {Integer} Investments
   */
  exports.prototype['Investments'] = undefined;
  /**
   * @member {Integer} LongTermReceivables
   */
  exports.prototype['LongTermReceivables'] = undefined;
  /**
   * @member {Integer} TradeDebtors
   */
  exports.prototype['TradeDebtors'] = undefined;
  /**
   * @member {Integer} ShortTermReceivables
   */
  exports.prototype['ShortTermReceivables'] = undefined;
  /**
   * @member {Integer} CashInHandAndAtBanks
   */
  exports.prototype['CashInHandAndAtBanks'] = undefined;
  /**
   * @member {Integer} RetainedEarnings
   */
  exports.prototype['RetainedEarnings'] = undefined;
  /**
   * @member {Integer} CapitalAndReserves
   */
  exports.prototype['CapitalAndReserves'] = undefined;
  /**
   * @member {Integer} LoansFromCreditInstitutions
   */
  exports.prototype['LoansFromCreditInstitutions'] = undefined;
  /**
   * @member {Integer} ShortTermCreditors
   */
  exports.prototype['ShortTermCreditors'] = undefined;



  return exports;
}));


